import {Injectable} from '@angular/core';
import {BaseApiService} from '../base-api.service';
import {GuestLink} from '../../../model/guest-link';

/** What a visitor may tell us when they start, all optional. */
export interface GuestStartRequest {
  name?: string;
  guestName?: string;
  guestEmail?: string;
  guestPhone?: string;
  /** The page that linked here, passed to the owner's webhook. */
  source?: string;
}

@Injectable({
  providedIn: 'root',
})
export class GuestLinkApiService extends BaseApiService {

  getLink(): Promise<{link: GuestLink | null}> {
    return this.get('/guest-link');
  }

  /** Create the owner's link, or replace it -- the old URL stops working. */
  replaceLink(): Promise<{link: GuestLink}> {
    return this.post('/guest-link', {});
  }

  updateLink(changes: {enabled?: boolean, folderId?: string}): Promise<{link: GuestLink}> {
    return this.put('/guest-link', changes);
  }

  /**
   * Start a project for a visitor. Called without a session -- the visitor has
   * none yet -- which the base service allows: it sends no Authorization header
   * when there is no signed-in user.
   */
  startProject(linkId: string, request: GuestStartRequest): Promise<{projectId: string}> {
    return this.post(`/guest-links/${encodeURIComponent(linkId)}/projects`, request);
  }

  /**
   * A visitor asks the business for an estimate on the project they measured.
   * Their anonymous session is enough; the canvas signs every visitor in.
   */
  requestEstimate(projectId: string, request: {
    guest: {name: string, email: string, phone: string},
    message: string,
    /** The page's language: the guest's confirmation email is written in it. */
    language?: string,
  }): Promise<{requested_on: number}> {
    return this.post(`/guest-projects/${encodeURIComponent(projectId)}/request`, request);
  }
}
